import React, { useState } from "react";
import { FaUserMd, FaClipboardList, FaMinus, FaPlus, FaFileMedical, FaUserCheck, FaClipboardCheck, FaChartLine, FaChartPie, FaHeartbeat, FaUserClock, FaHospital, FaProcedures, FaStopwatch, FaBed, FaExchangeAlt, FaClock, FaMoneyBillWave, FaHouseUser, FaUserShield } from "react-icons/fa";

import Medpalm from "../../../assests/Healthsoftware/PFM.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "title": "Real-Time Patient Tracking",
        "description": "Utilizes RFID, IoT, and GPS-based tracking systems to monitor patient movements within hospital facilities in real time. Enhances patient safety by preventing unauthorized departures, reducing the risk of patient elopement, and ensuring timely response in emergency situations. Facilitates better coordination between medical staff and departments by providing instant location updates, streamlining patient transfers, and improving overall hospital workflow efficiency."
    },
    {
        "title": "Bed & Resource Management",
        "description": "Optimizes hospital bed occupancy and resource utilization through real-time data analytics. Predicts bed availability, reduces patient wait times, and prevents both overuse and underuse of critical care units. Assists hospital administrators in making informed decisions about patient assignments, ensuring timely discharges, and allocating resources efficiently to improve patient flow and reduce overcrowding in high-demand areas."
    },
    {
        "title": "Emergency Department Optimization",
        "description": "Enhances emergency room efficiency by reducing congestion, streamlining triage processes, and improving patient experience. Implements real-time queue management, AI-driven patient prioritization, and data-driven scheduling to ensure that critical cases receive immediate attention while reducing overall wait times. Predictive analytics help anticipate patient surges, allowing hospitals to allocate resources effectively and minimize bottlenecks."
    },
    {
        "title": "AI-Powered Predictive Analytics",
        "description": "Uses artificial intelligence to analyze historical patient admission trends, predict surges, and optimize hospital staffing levels. Enables hospitals to proactively prepare for high-demand periods by forecasting seasonal variations, emergency spikes, and peak hours. Helps ensure adequate staff coverage, reduce operational strain, and improve resource allocation, leading to better patient care and workforce efficiency."
    },
    {
        "title": "Automated Discharge Planning",
        "description": "Improves hospital discharge processes by automating paperwork, coordinating follow-up care, and reducing unnecessary delays. Ensures a seamless transition for patients by integrating post-discharge care plans, medication reconciliation, and appointment scheduling. By optimizing discharge workflows, hospitals can free up critical beds faster, reduce readmission risks, and enhance overall patient satisfaction."
    },
    {
        "title": "Integrated Workflow Automation",
        "description": "Enhances coordination across hospital departments by automating administrative tasks, optimizing scheduling, and facilitating real-time communication between healthcare providers. Reduces manual paperwork, minimizes errors, and ensures smooth patient transitions between departments, such as from emergency rooms to inpatient units or from surgery to recovery. Improves operational efficiency, reduces administrative burdens, and enhances patient care continuity."
    }
]

const features = [
    { icon: <FaStopwatch className="text-[#2a627a] text-lg" />, text: "Real-time patient tracking to minimize wait times and delays." },
    { icon: <FaBed className="text-[#2a627a] text-lg" />, text: "Automated bed management for better hospital resource allocation." },
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "AI-driven predictive analytics to forecast patient admission trends." },
    { icon: <FaExchangeAlt className="text-[#2a627a] text-lg" />, text: "Seamless department coordination for smooth patient transitions." },
    { icon: <FaUserShield className="text-[#2a627a] text-lg" />, text: "HIPAA-compliant data security for patient movement tracking." },
    { icon: <FaClipboardList className="text-[#2a627a] text-lg" />, text: "Custom dashboards for real-time monitoring and reporting." }
];
const benefits = [
    { icon: <FaClock className="text-[#2a627a] text-lg" />, text: "Reduces patient wait times and improves hospital efficiency." },
    { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "Enhances patient care quality with faster service delivery." },
    { icon: <FaUserCheck className="text-[#2a627a] text-lg" />, text: "Improves staff productivity by streamlining workflow processes." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Minimizes overcrowding in emergency departments and waiting areas." },
    { icon: <FaMoneyBillWave className="text-[#2a627a] text-lg" />, text: "Optimizes resource utilization, reducing hospital operational costs." },
    { icon: <FaHouseUser className="text-[#2a627a] text-lg" />, text: "Facilitates timely discharges, improving patient satisfaction scores." }
];
const consentItems = [
    { icon: <FaUserClock className="text-[#2a627a] text-lg" />, text: "Patient Flow Coordinator – Monitors and optimizes patient movement within healthcare facilities." },
    { icon: <FaProcedures className="text-[#2a627a] text-lg" />, text: "Bed Management Specialist – Manages hospital bed availability and patient assignments." },
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Healthcare Operations Manager – Ensures smooth coordination between departments for efficient patient care." },
    { icon: <FaChartPie className="text-[#2a627a] text-lg" />, text: "Healthcare Data Analyst – Uses analytics to track patient flow trends and improve efficiency." },
    { icon: <FaHospital className="text-[#2a627a] text-lg" />, text: "Emergency Department Manager – Optimizes patient triage and reduces ER wait times." },
    { icon: <FaClipboardCheck className="text-[#2a627a] text-lg" />, text: "Discharge Planning Specialist – Coordinates timely and safe patient discharges to reduce hospital stays." }
];

const PatientFlowManagement = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 ">Patient Flow Management  </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Streamline patient journeys with efficient scheduling, real-time tracking, and optimized resource allocation.
                    </p>
                </div>

                {/* What is Consent? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-2xl hover:shadow-2xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is Patient Flow Management?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Patient Flow Management is crucial in healthcare to reduce wait times, optimize hospital resources, and enhance patient experience. HikeHealth GS provides intelligent, AI-driven solutions to streamline patient movement across clinics, hospitals, and emergency departments.
                        </p>
                    </div>
                </section>

                {/* Role of Patient Flow Management*/}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 ">
                        Role of Patient Flow Management
                    </h2>

                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {consentItems.map((item, index) => (
                            <motion.div
                                key={index}
                                className="relative z-10 bg-gray-300 bg-opacity-70 hover:bg-gray-300 text-gray-800 p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl"
                                initial={{ opacity: 0, x: -100 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1 }}
                            >
                                <span className="text-[#2a627a] text-lg">{item.icon}</span>
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 ">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="relative bg-gray-300 bg-opacity-70 hover:bg-gray-300 text-gray-800 p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl flex flex-col items-center text-center"
                                initial={{ opacity: 0, x: 20 }}
                                whileInView={{ opacity: 1, x: -10 }}
                                transition={{ duration: 1 }}
                            // viewport={{ once: true }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium mt-3">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-bg-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-bg-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default PatientFlowManagement;
